// extracted by css-extract-rspack-plugin
export default {"crop-image-content-input":"ImageInput-module__crop-image-content-input--Tljq8","cropImageContentInput":"ImageInput-module__crop-image-content-input--Tljq8"};